const { BlobServiceClient } = require('@azure/storage-blob');

const containerName = 'vtt';
let storageAccountName = 'srmdmediastorage';
let sasToken =
    'sv=2022-11-02&ss=bfqt&srt=sco&sp=rwdlacupiytfx&se=2055-09-26T07:32:57Z&st=2025-03-17T23:32:57Z&spr=https,http&sig=7DmsxYQ8hN4EYGL7GyN56Lexvqy5ZzbEzTTc85DMlmg%3D';
const vttURLPrefix = 'https://srmdmediastorage.blob.core.windows.net/vtt/';
const textURLPrefix = 'https://srmdmediastorage.blob.core.windows.net/text/';

export async function uploadToBlobStorage(fileName, content, type = 'vtt') {
    const blobName = fileName.replace(type === 'vtt' ? vttURLPrefix : textURLPrefix, '');
    //console.log("connection string", `https://${storageAccountName}.blob.core.windows.net/?${sasToken}`);
    const blobSasUrl = `https://${storageAccountName}.blob.core.windows.net/?${sasToken}`;
    const blobServiceClient = new BlobServiceClient(blobSasUrl);
    const containerClient = blobServiceClient.getContainerClient(type === 'vtt' ? 'vtt' : 'text');
    const blockBlobClient = containerClient.getBlockBlobClient(blobName);
    try {
        const uploadBlobResponse = await blockBlobClient.upload(content, content.length);
        console.log(`Upload block blob ${blobName} to ${type} container successfully`, uploadBlobResponse.requestId);
    } catch (error) {
        console.error(`Error uploading blob ${blobName} to ${type} container`, error);
        throw error;
    }
}
